import availableStates from '../../../../../helpers/availableStatesHelper'
import availableLanguages from '../../../../../helpers/availableLanguagesHelper'
import availableEducationLevels from '../../../../../helpers/availableEducationLevelsHelper'

export default function () {
    return {
        availableStates,
        availableLanguages,
        availableEducationLevels,
        availableCities: [],
        isLoadingCities: false,
        isRegistered: false,
        isMounted: false,
        showAdditionalLanguagesSelection: false,
        showVaccinationCertificate: false,
        user: {
            name: '',
            cpf: '',
            rg: '',
            birthDate: '',
            phone: '',
            gender: '',
            vaccinationCertificateFile: null,
            vaccinationCertificate: null,
            vaccinationCertificateUrl: null,
            biography: '',
            address: {
                zipCode: '',
                street: '',
                number: null,
                complement: '',
                neighbourhood: '',
                city: '',
                state: ''
            },
            company: {
                cnpj: '',
                name: ''
            },
            socialNetworks: {
                instagram: null,
                facebook: null,
                youtube: null,
                linkedin: null,
                tiktok: null
            },
            password: '',
            passwordConfirmation: '',
            bankData: '',
            courses: [],
            languages: [],
            additionalLanguages: [],
            educationLevel: null,
            formationArea: null
        },
        showPassword: false,
        showPasswordConfirmation: false,
        formattedUserBirthDate: '',
        showBirthDatePicker: false,
        errors: {
            name: '',
            cpf: '',
            rg: '',
            birthDate: '',
            phone: '',
            gender: '',
            socialNetworks: '',
            password: '',
            passwordConfirmation: '',
            bankData: '',
            biography: '',
            vaccinationCertificate: '',
            'address.zipCode': '',
            'address.street': '',
            'address.numer': '',
            'address.complement': '',
            'address.neighbourhood': '',
            'address.city': '',
            'address.state': '',
            'company.cnpj': '',
            'company.name': ''
        },
        successModal: false,
        errorMessage: {
            show: false,
            content: null,
            timeout: 5000
        },
        successMessage: {
            show: false,
            content: null,
            timeout: 5000
        },
        editorToolbar: [
            ['bold'],
            [{ list: "ordered" }, { list: "bullet" }]
        ]
    }
}
